import React, { useEffect, useState, useRef } from "react";
import classes from "./MonthlyDeductions.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
import { Pen, Trash2, Printer } from "lucide-react";
import axios from "axios";
import { Eye, Edit, Trash } from 'lucide-react';
import api, { BASE_URL, getAuthHeaders } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Swal from 'sweetalert2';
import MonthlyDeductionModal from "./SavingModal/MonthlyDeductionModal";
import DeductionUploadModal from "./DeductionUploadModal";
import DeductionUploadModal1 from "./DeductionUploadModal1";



const ActualMonthlyDeductions = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectMetrics, setSelectedMetrics] = useState(null);
  const printRef = useRef();
  const [openCashReciept, setOpenCashReciept] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const [total, setTotal] = useState(0);  
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

     const [openDisAppModalExcel, setOpenDisAppModalExcel] = useState(false);
     const [openDisAppModalExcel1, setOpenDisAppModalExcel1] = useState(false);





  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     try {
  //       const res = await axios.get(`${BASE_URL}/v1/fetch-purchases-invoice`, {
  //         headers: getAuthHeaders(),
  //       });
  //       if (res.data && res.data.status && Array.isArray(res.data.data)) {
  //         setInvoices(res.data.data);
  //       }
  //     } catch (err) {
  //       setInvoices([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchInvoices();
  // }, []);


const fetchInvoices12 = async () => {
  setLoading(true);

  try {
    const res = await api.get("/v1/get-all-deductions");

    const savings = res.data?.data?.data;

    if (res.data?.status && Array.isArray(savings)) {
      setInvoices(savings);
    } else {
      setInvoices([]);
    }
  } catch (error) {
    console.error(error);
    setInvoices([]);
  } finally {
    setLoading(false);
  }
};

const fetchInvoices = async (page = 1) => {
  setLoading(true);

  try {
    const res = await api.get(`/v1/get-all-deductions?page=${page}`);

    if (res.data?.status) {
      const response = res.data.data;

      setInvoices(response.data || []);
      setCurrentPage(response.current_page);
      setLastPage(response.last_page);
      setPerPage(response.per_page);
      setTotal(response.total);
    } else {
      setInvoices([]);
    }
  } catch (err) {
    console.error(err);
    setInvoices([]);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchInvoices();
}, []);

  const statusClass = (status) => {
    if (status === "Success") return classes.greenStatus;
    if (status === "Pending") return classes.yellowStatus;
    return classes.redStatus;
  };


  const getDeliveryStatus = (item) => {
    const rawValue = item?.is_supplied ?? item?.delivery_status ?? item?.status;

    if (rawValue == 1 || rawValue === "1") {
      return { text: "delivered", class: classes.greenStatus };
    }
    if (rawValue == 0 || rawValue === "0") {
      return { text: "not delivered", class: classes.yellowStatus };
    }

    return { text: String(rawValue || "not delivered"), class: classes.yellowStatus };
  };
  useEffect(() => {


    const fetchMetrics = async () => {
      try {
        const res = await api.get("/v1/metrics/purchase-invoice-matrix");
        if (res.data && res.data.status && res.data.data) {
          setSelectedMetrics(res.data.data);
        }
      } catch (err) {
        setSelectedMetrics(null);
      }
    };
    fetchMetrics();
  }, []);

  const handlePrint = (rowData) => {
    navigate("/invoice-previeww", {
      state: { invoice: rowData, pageTitle: "Purchase Invoice" },
    });
  };

  const handleReversePurchaseInvoice = async (item) => {
    // Confirm deletion
    const result = await Swal.fire({
      title: 'Reverse Purchase Invoice',
      text: 'Are you sure you want to reverse this purchase invoice? This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reverse it!'
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const response = await api.post(`/v1/reverse-purchase-invoice`, {
        invoice_id: item.id,
        invoice_number: item.invoice_number || item.document_number
      });

      if (response.status === 200 || response.status === 201) {
        // Remove the item from the table
        setInvoices(invoices.filter(invoice => invoice.id !== item.id));
        Swal.fire({
          title: 'Success!',
          text: 'Purchase invoice reversed successfully.',
          icon: 'success',
          confirmButtonColor: '#3085d6'
        });
      }
    } catch (error) {
      console.error("Failed to reverse invoice:", error);
      Swal.fire({
        title: 'Error!',
        text: error.response?.data?.message?.invoice_number?.[0] || 'Error reversing purchase invoice. Please try again.',
        icon: 'error',
        confirmButtonColor: '#3085d6'
      });
    }
  };




  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />
        <div className={classes.Container}>
        {/* <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div> */}

        <header className={classes.Header}>
          <h2 className={classes.Title}>Actual Monthly Deductions Slip</h2>
          <h1 className={classes.Titles}>
            Process, View and Manage Actual Monthly Deductions Slip for Members
          </h1>
        </header>

        {/* <div className={classes.entrjj}>
          <div className={classes.allkads}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Savings</p>
                <p className={classes.kdptg1}>
               
                0
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>This month</p>
                </div>
              </div>
            </div>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Withdrawal</p>
                <p className={classes.kdptg2}>
               
                0
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total Withdrawal</p>
                </div>
              </div>
            </div>
            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>This month</p>
                <p className={classes.kdptg4}>
               
                0
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total invoices</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search deductions" />
            </div>
            {/* <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Status</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div> */}

            {/* <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div> */}
          </div>
          <div style={{ display: "flex", gap: "15px" }}>
            <button className={classes.btnss1} 
            onClick={() => setOpenDisAppModalExcel1(true)}
            > + Upload Excel</button>
            <button className={classes.btnss} 
            // onClick={() => 
            // navigate("/transactions/purchase-invoice/purchase/new-item")}
            onClick={() => setOpenCashReciept(true)}
            > 
            + New Monthly Deduction</button>
          </div>
        </div>

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr>
                  <th>S/N</th>
                  <th>Members Name</th>
                  <th>Savings/Loan Type</th>
                  <th>Description</th>
                  <th>Amount</th>
                  <th>Month</th>
                  {/* <th>Transaction Date</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>

                {loading
                  ? Array(5)
                    .fill()
                    .map((_, idx) => (
                      <tr key={idx}>
                        {Array(7)
                          .fill()
                          .map((_, i) => (
                            <td key={i}>
                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </td>
                          ))}
                      </tr>
                    ))
                  : invoices.length === 0 ? (
                    <tr>
                      <td colSpan={7} style={{ textAlign: "center" }}>
                        No monthly deductions found.
                      </td>
                    </tr>
                  ) : (
                    invoices.map((item, index) => (
                      <tr key={item.id}>
                          <td>{index + 1 + (currentPage - 1) * perPage}</td>

                          <td>{item.member?.name}</td>

                          <td>{item.mode == "saving" ? item.savings?.product_name : item.loan?.loan_name}</td>

                          <td>{item.description}</td>

                          <td style={{ textAlign: "right" }}>
                            ₦{Number(item.amount).toLocaleString("en-NG", {
                              minimumFractionDigits: 2,
                            })}
                          </td>

                          <td>{item.month}</td>

                          {/* <td>{item.transaction_date}</td> */}

                          <td className={classes.tableCell}>
                            <div className={classes.actionIcons}>
                              <Eye size={16} style={{ color: "rgba(22,163,74,1)" }} />
                              <Edit
                                size={16}
                                style={{
                                  margin: "0 8px",
                                  color: "rgba(37,99,235,1)",
                                  cursor: "pointer",
                                }}
                              />
                              <Trash
                                size={16}
                                style={{ color: "rgb(255,2,2)", cursor: "pointer" }}
                              />
                            </div>
                          </td>
                      </tr>
                    ))
                  )}
              </tbody>
            </table>


          </table>

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>

              <button
                disabled={currentPage === 1}
                onClick={() => fetchInvoices(1)}
              >
                First
              </button>

              <button
                disabled={currentPage === 1}
                onClick={() => fetchInvoices(currentPage - 1)}
              >
                Previous
              </button>

              <span>
                Page {currentPage} of {lastPage}
              </span>

              <button
                disabled={currentPage === lastPage}
                onClick={() => fetchInvoices(currentPage + 1)}
              >
                Next
              </button>

              <button
                disabled={currentPage === lastPage}
                onClick={() => fetchInvoices(lastPage)}
              >
                Last
              </button>

              <span className={classes.pageText}>
                Displaying{" "}
                {Math.min((currentPage - 1) * perPage + 1, total)}
                {" - "}
                {Math.min(currentPage * perPage, total)}
                {" of "}
                {total}
              </span>

            </div>
          </div>


        </div>
      </div>
      <MonthlyDeductionModal isOpen={openCashReciept} onClose={() => setOpenCashReciept(false)} 
onSuccess={fetchInvoices}
      // onSuccess={handlePaymentSuccess} 
      />

         <DeductionUploadModal1
        isOpen={openDisAppModalExcel1}
        onClose={() => setOpenDisAppModalExcel1(false)}
        onUploadDocument={() => {
          setOpenDisAppModalExcel1(false); // Close LoanUpload1
          setOpenDisAppModalExcel(true);   // Open LoanUpload
        }}
      />
       <DeductionUploadModal 
       isOpen={openDisAppModalExcel} 
       onClose={() => setOpenDisAppModalExcel(false)}
        onSuccess={fetchInvoices12}
        />      
      <Footer />
    </div>
  );
};

export default ActualMonthlyDeductions;
